<template>
    <div>
        <div class="mb-2 flex flex-row gap-2">
            <FileUploadButton
                title="upload_asset_secondary_market_import"
                accept=".csv, .xlsx, .xls"
                mode="private"
                :show-delete="false"
                :deletable="false"
                :clearable="false"
                :file-name="secondaryMarketImportFileName"
                @submit="onAssetSecondaryMarketImportUpload"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import FileUploadButton from '@partials/actions/FileUploadButton.vue'
import { UploadFileResponse } from '@src/utils/api/s3'
import { ref } from 'vue'

const props = defineProps<{
    modelValue: UploadFileResponse | null
}>()

const emit = defineEmits<{
    (e: 'update:modelValue', value: UploadFileResponse | null): void
}>()

const secondaryMarketImportFileName = ref<string | null>(null)

function onAssetSecondaryMarketImportUpload(
    response: UploadFileResponse | null,
    fileName: string | null
) {
    if (response && response.key) {
        secondaryMarketImportFileName.value = fileName
        emit('update:modelValue', response)
    } else {
        secondaryMarketImportFileName.value = null
        emit('update:modelValue', null)
    }
}
</script>

<style scoped></style>
